import classNames from "classnames/bind"
import PropTypes from "prop-types"
import React from "react"

import { useTranslate } from "context/translateContext"
import tickIcon from "shared/images/tick_plan.svg"

import { getFeatureEligibility } from "../../../helpers/featureEligibility"

import gridStyles from "../../../components/Plans.module.css"

const cx = classNames.bind(gridStyles)

const bodyClass = cx("row", "planCell")

const RETURNS = "returns-international-active"

const Returns = ({ plans }) => {
  const { t: translate } = useTranslate()
  const isVisible = getFeatureEligibility({ featureName: RETURNS, plans })
  return (
    isVisible && (
      <>
        <div
          className={cx(bodyClass, "mobileHeading", "featureDescriptionCell")}
        >
          <p className={gridStyles.sectionTitle}>{translate("Returns")}</p>
          <p className="w500 fs-16 m-b-0">
            {translate("Increase buyer confidence")}
          </p>
          <p className={gridStyles.sectionHelperText}>
            {translate(
              "Free returns for your buyers with fully insured deliveries, managed by Webinterpret"
            )}
          </p>
        </div>
        {plans.map(plan => (
          <div
            key={`RETURNS_${plan.name}`}
            className={cx(
              bodyClass,
              "flex-container",
              "f-j-center",
              "f-a-center"
            )}
          >
            <img
              src={tickIcon}
              className={gridStyles.tickIcon}
              alt="Tick icon"
            />
          </div>
        ))}
      </>
    )
  )
}

Returns.propTypes = { plans: PropTypes.array }
Returns.defaultProps = { plans: [] }

export default Returns
